import React from 'react'
import { Text, TextLink, Container } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import { useLocaleText } from '../../locale'
import { useStoreId } from '@moonpig/web-core-stores'

const StyledContainer = styled(Container)`
  ${s({
    p: 6,
    m: 6,
    mt: 3,
    bgcolor: 'colorBackground01',
    borderRadius: 2,
    border: 1,
    borderColor: 'colorBlack05',
  })}
`

const StyledTextLink = styled(TextLink)`
  ${s({ color: 'colorInteractionControl' })}
`

export const DisclaimerMessage = () => {
  const t = useLocaleText()
  const storeId = useStoreId()
  return (
    <StyledContainer>
      <Text typography={'typeBodyCaption'} color={'colorInteractionControl'}>
        {t('concierge_chat.input_disclaimer_text')}{' '}
        <StyledTextLink
          href={t('concierge_chat.input_disclaimer_privacy_policy_url', {
            region: storeId,
          })}
          target="_blank"
        >
          {t('concierge_chat.input_disclaimer_privacy_policy')}
        </StyledTextLink>
        .
      </Text>
    </StyledContainer>
  )
}
